<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    pathPc: string
    pathSp?: string //PCとSPで別々の画像を使用したい場合は、この値にセットしてください
    pathPcWebp?: string //WebP画像非対応のブラウザ用に、通常の拡張子（jpg,png,etc...）の画像もセットする必要があります
    pathSpWebp?: string
    altText?: string
    widthPc?: number //Core Web Vitals向上のため、width、heightはできる限り指定してください。
    heightPc?: number
    widthSp?: number //sp用画像を使用する場合、sp用画像のwidth、heightを指定できます。
    heightSp?: number
    isLazy?: boolean //一般的にファーストビューに該当する画像はLazyLoad（画像の遅延読み込み）すべきではないので、その場合「false」にしてください
    decoding?: 'sync' | 'async' | 'auto' //画像のデコード方法を指定
    imgClass?: string | { [key: string]: boolean } | (string | { [key: string]: boolean })[]
  }>(),
  {
    pathSp: '',
    pathPcWebp: '',
    pathSpWebp: '',
    altText: '',
    widthPc: undefined,
    heightPc: undefined,
    widthSp: undefined,
    heightSp: undefined,
    isLazy: true,
    decoding: 'auto',
    imgClass: '',
  }
)

let sourceAttrsList: {
  media?: string
  type?: string
  srcset: string
  width?: number
  height?: number
}[] = []

sourceAttrsList.unshift({
  srcset: props.pathPc,
  width: props.widthPc,
  height: props.heightPc,
})
if (props.pathPcWebp !== '') {
  sourceAttrsList.unshift({
    type: 'image/webp',
    srcset: props.pathPcWebp,
    width: props.widthPc,
    height: props.heightPc,
  })
}
if (props.pathSp !== '') {
  sourceAttrsList = sourceAttrsList.map((attrs) => ({ media: '(min-width: 768px)', ...attrs }))

  sourceAttrsList.unshift({
    media: '(max-width: 767px)',
    srcset: props.pathSp,
    width: props.widthSp,
    height: props.heightSp,
  })
  if (props.pathSpWebp !== '') {
    sourceAttrsList.unshift({
      media: '(max-width: 767px)',
      type: 'image/webp',
      srcset: props.pathSpWebp,
      width: props.widthSp,
      height: props.heightSp,
    })
  }
}
</script>

<template>
  <picture>
    <source v-for="(attrs, key) in sourceAttrsList" :key="key" v-bind="attrs" />
    <img
      :loading="props.isLazy ? 'lazy' : 'eager'"
      :decoding="props.decoding"
      :src="props.pathPc"
      :alt="props.altText"
      :width="props.widthPc"
      :height="props.heightPc"
      :class="props.imgClass"
    />
  </picture>
</template>
